export default "__VITE_ASSET__2bb0889e__"